import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import {
  GetLineAppointmentForChargeDocument,
  LineAppointmentForChargeFragment,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { lineVisitorChargeModalState } from '~/state/reception/atoms';

export const useFetchAppointment = (): LineAppointmentForChargeFragment | null => {
  const { isOpen, appointmentId } = useAtomValue(lineVisitorChargeModalState);
  const [getAppointment, { data }] = useLazyQuery(GetLineAppointmentForChargeDocument);

  const appointment = getNode(data, 'Appointment') || null;

  useEffect(() => {
    if (isOpen && appointmentId) {
      getAppointment({ variables: { appointmentId } });
    }
  }, [appointmentId, getAppointment, isOpen]);

  return appointment;
};
